import React, { useState } from 'react';
import CustomHeader from '../components/layout/CustomHeader';
import CustomFooter from '../components/layout/CustomFooter';
import './VerifyCertificate.css';

const VerifyCertificate = () => {
  const [certId, setCertId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!certId.trim()) return;
    setLoading(true);
    setResult(null);
    try {
      const res = await fetch('/api/v1/certificates/verify?cert_id=' + encodeURIComponent(certId.trim()));
      const data = await res.json();
      setResult(data);
    } catch (err) {
      setResult({ status: 'error', message: 'Could not reach the server. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const renderResult = () => {
    if (!result) return null;
    if (result.status === 'valid') {
      return (
        <div className="verify-result success">
          <div className="result-icon">&#10003;</div>
          <div className="result-status">Certificate Verified</div>
          <div className="result-name">{result.student_name}</div>
          <div className="result-course">{result.course_name}</div>
        </div>
      );
    }
    if (result.status === 'revoked') {
      return (
        <div className="verify-result error">
          <div className="result-icon">&#128683;</div>
          <div className="result-status">Certificate Revoked</div>
          <div className="result-message">This certificate has been revoked and is no longer valid.</div>
        </div>
      );
    }
    if (result.status === 'not_found') {
      return (
        <div className="verify-result error">
          <div className="result-icon">&#10007;</div>
          <div className="result-status">Certificate Not Found</div>
          <div className="result-message">No certificate found with that ID. Please check and try again.</div>
        </div>
      );
    }
    return (
      <div className="verify-result error">
        <div className="result-icon">&#9888;</div>
        <div className="result-status">Verification Failed</div>
        <div className="result-message">{result.message || 'An unexpected error occurred.'}</div>
      </div>
    );
  };

  return (
    <>
      <CustomHeader activePage="verify" />

      <section className="verify-hero">
        <h1>Verify Certificate</h1>
        <p>Enter your certificate ID to instantly verify its authenticity and view your credentials.</p>
      </section>

      <section className="verify-section">
        <div className="verify-card">
          <form onSubmit={handleVerify}>
            <label htmlFor="certId">Certificate ID</label>
            <input
              type="text"
              id="certId"
              className="verify-input"
              placeholder="e.g. IUV-LD-DA-2026-0001"
              value={certId}
              onChange={(e) => setCertId(e.target.value)}
              required
            />
            <button type="submit" className="verify-btn" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify Certificate'}
            </button>
          </form>
          {renderResult()}
        </div>
      </section>

      <CustomFooter />
    </>
  );
};

export default VerifyCertificate;
